module.exports = __webpack_public_path__ + "static/media/playlist-remove.b95386fb.svg";